<script>
export default {
  props: {
    formData: {
      type: Object,
      required: false,
    },
  },
};
</script>

<template>
  <div class="layout-container">
    <header class="fixed-header d-flex align-items-center">
      <slot name="content-header" :form="formData"></slot>
    </header>

    <div class="scroller-container">
      <main class="content-body">
        <!-- Main content that needs scrolling -->
        <slot name="content-body" :form="formData"></slot>
      </main>

      <footer class="fixed-footer">
        <!-- Buttons content -->
        <div class="footer-btns">
          <slot name="content-footer" :form="formData"></slot>
        </div>
      </footer>
    </div>
  </div>
</template>

<style lang="scss">
.page-content {
  padding-bottom: unset !important;
  //   padding-top: unset !important;
  padding-inline-end: unset !important;
}
// .breadcrumb {
//   padding: 0 0 0 24px !important;
// }
.scroller-container {
  height: calc(100vh - 197px);
  overflow-y: auto;
  padding-inline-end: 4px;
}
.scroller-container::-webkit-scrollbar {
  width: 11px;
  height: 11px;
}

.scroller-container::-webkit-scrollbar-thumb {
  background-color: #787878;
  border-radius: 8px;
  border: 2px solid transparent; /* Optional: Add space around thumb */
  background-clip: content-box; /* Ensures thumb respects border-radius */
}

.scroller-container::-webkit-scrollbar-thumb:hover {
  border: 0 solid transparent;
}

.scroller-container::-webkit-scrollbar-track {
  background-color: #d1d1d1;
  border-radius: 8px;
}

.layout-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .page-top-header {
    margin-bottom: unset !important;
  }
}

.fixed-header {
  //   margin-top: 94px; // navbar height (81) and 24 padding below it
  height: 27px; // max-height that could get if there's buttons
  margin-bottom: 24px;
  flex-shrink: 0; /* Prevents shrinking */
  span {
    margin-inline-end: 40px;
  }
}

.header-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 127px;
  height: 27px;
  color: #fff;
  background: #103f5e;
  border-radius: 13.5px;
}

.fixed-footer {
  margin-top: 24px;
  //   height: 69px;
  flex-shrink: 0; /* Prevents shrinking */
  .footer-btns {
    padding-top: 16px;
    padding-inline-end: 0;
    padding-bottom: 16px;
    padding-inline-start: 32px;
    display: flex;
    gap: 24px;
  }
}
</style>
